import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.744 18.75h16.5M5.247.75h13.5s1.5 0 1.5 1.5v19.5s0 1.5-1.5 1.5h-13.5s-1.5 0-1.5-1.5V2.25s0-1.5 1.5-1.5"
    }, null, -1)
  ]));
}
const computerDeviceMobileTablet = { render };
export {
  computerDeviceMobileTablet as default,
  render
};
//# sourceMappingURL=computer-device-mobile-tablet.svg.js.map
